module.exports = __webpack_public_path__ + "assets/img/url-tab-active.9afeb359.svg";